import React from 'react';
import { HeroSection } from './components/HeroSection';
import { StatsBar } from './components/StatsBar';
import { TransformationSection } from './components/TransformationSection';
import { PainPointsSection } from './components/PainPointsSection';
import { KitContentsSection } from './components/KitContentsSection';
import { InstantAccessSection } from './components/InstantAccessSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { AboutSection } from './components/AboutSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
import { useMetaPixel } from './hooks/useMetaPixel';
interface AppProps {
  /** Ocultá los testimonios hasta tener reseñas reales cargadas. */
  showTestimonials?: boolean;
  showSocialProof?: boolean;
}
export function App({
  showTestimonials = true,
  showSocialProof = true
}: AppProps) {
  useMetaPixel();
  return <div className="min-h-screen w-full bg-brand-cream font-sans text-brand-text selection:bg-brand-green/30" data-id="element-0" data-mp="3recf5n6xuth9">
      <main data-id="element-1" data-mp="7ssnarqpf34">
        <HeroSection data-id="element-2" data-mp="2zl3dbpgpde7f" />
        <StatsBar data-id="element-3" data-mp="2zlv6yuqqp1v2" />
        <TransformationSection data-id="element-4" data-mp="2zmeo498kfm81" />
        <PainPointsSection data-id="element-5" data-mp="2zn66ujh2dpgw" />
        <KitContentsSection data-id="element-6" data-mp="33mf623uvifju" />
        <InstantAccessSection data-id="element-7" data-mp="33nq921ghvj9w" />
        <BonusesSection data-id="element-8" data-mp="33oriy2lrxzq1" />
        <PricingSection data-id="element-9" data-mp="38lrs4mdx7ild" />
        <GuaranteeSection data-id="element-10" data-mp="38li77d7qg1mj" />
        {showTestimonials && <TestimonialsSection data-id="element-11" data-mp="38nupjrheke04" />}
        <AboutSection data-id="element-12" data-mp="3dkl0y1i9ilf7" />
        <FAQSection data-id="element-13" data-mp="3dlw5i3jj7x7d" />
        <FinalCTASection data-id="element-14" data-mp="3dmfozootytni" />
      </main>
      <Footer data-id="element-15" data-mp="nvj3xh1mugq9" />
      {showSocialProof && <SocialProofPopup data-id="element-16" data-mp="nuhhkgf627t8" />}
    </div>;
}